(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const BOOTSTRAP_KEY = '__proCinematicHeroBootstrapV1';

  const absoluteUrl = (src) => {
    try {
      return new URL(src, document.baseURI).href;
    } catch (error) {
      return src;
    }
  };

  const hasScript = (src) => {
    const target = absoluteUrl(src);
    return Array.from(document.scripts).some((script) => script.src === target);
  };

  const loadScript = (src, marker) => {
    if (!src || hasScript(src)) return;

    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.defer = true;
    script.dataset[marker] = 'true';
    document.head.appendChild(script);
  };

  const scan = (scope = document) => {
    const roots = [];

    if (scope instanceof Element && scope.matches('[data-pro-cinematic-hero-runtime]')) {
      roots.push(scope);
    }

    scope.querySelectorAll?.('[data-pro-cinematic-hero-runtime]').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      loadScript(root.dataset.pchCoreSrc, 'proCinematicHeroCore');
      loadScript(root.dataset.pchModuleSrc, 'proCinematicHeroModule');
    });
  };

  if (window[BOOTSTRAP_KEY]) {
    window[BOOTSTRAP_KEY].scan(document);
    return;
  }

  window[BOOTSTRAP_KEY] = { scan };

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });

  scan(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-media-card-orbit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const BOOTSTRAP_KEY = '__proMediaCardOrbitBootstrapV1';

  const absoluteUrl = (src) => {
    try {
      return new URL(src, document.baseURI).href;
    } catch (error) {
      return src;
    }
  };

  const hasScript = (src) => {
    if (!src) return false;
    const target = absoluteUrl(src);
    return Array.from(document.scripts).some((script) => script.src === target);
  };

  const loadScript = (src, marker) => {
    if (!src || hasScript(src)) return;

    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.defer = true;
    script.dataset[marker] = 'true';
    document.head.appendChild(script);
  };

  const scan = (scope = document) => {
    const roots = [];

    if (scope instanceof Element && scope.matches('[data-pro-media-card-orbit-runtime]')) {
      roots.push(scope);
    }

    scope.querySelectorAll?.('[data-pro-media-card-orbit-runtime]').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (root.hasAttribute('data-pro-video-lifecycle') && !window.__proVideoLifecycleCoreV1) {
        loadScript(root.dataset.pmcoCoreSrc, 'proMediaCardOrbitCore');
      }

      if (!window.__proMediaOrbitV1) {
        loadScript(root.dataset.pmcoModuleSrc, 'proMediaCardOrbitModule');
      }
    });
  };

  if (window[BOOTSTRAP_KEY]) {
    window[BOOTSTRAP_KEY].scan(document);
    return;
  }

  window[BOOTSTRAP_KEY] = { scan };

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });

  scan(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-parallax-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const CONTROLLER_KEY = '__proParallaxBannerController';

  if (window[CONTROLLER_KEY]) {
    window[CONTROLLER_KEY].scan(document);
    return;
  }

  const instances = new Map();
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let frame = null;

  const strengthMap = {
    subtle: 0.12,
    medium: 0.24,
    strong: 0.36
  };

  const schedule = () => {
    if (frame !== null) return;

    frame = window.requestAnimationFrame(() => {
      frame = null;
      updateVisible();
    });
  };

  const shouldMove = (instance) => {
    if (!instance.visible || reducedMotionQuery.matches) return false;

    if (mobileQuery.matches) {
      return instance.mobileMotion === 'subtle';
    }

    return true;
  };

  const getStrength = (instance) => {
    if (mobileQuery.matches) return 0.16;
    return strengthMap[instance.strength] || strengthMap.medium;
  };

  const resetInstance = (instance) => {
    instance.root.classList.remove('is-parallax-active');
    instance.media.style.transform = 'translate3d(0, 0, 0)';
  };

  const updateInstance = (instance) => {
    if (!shouldMove(instance)) {
      resetInstance(instance);
      return;
    }

    const rect = instance.root.getBoundingClientRect();
    const viewportHeight =
      window.visualViewport?.height ||
      window.innerHeight ||
      document.documentElement.clientHeight;

    const travel = viewportHeight + rect.height;

    if (travel <= 0) {
      resetInstance(instance);
      return;
    }

    const progress = Math.min(
      1,
      Math.max(0, (viewportHeight - rect.top) / travel)
    );

    const centeredProgress = (progress - 0.5) * 2;
    const maxShift = rect.height * getStrength(instance);
    const shift = Math.round(centeredProgress * maxShift);

    instance.root.classList.add('is-parallax-active');
    instance.media.style.transform =
      `translate3d(0, ${shift}px, 0)`;
  };

  const updateVisible = () => {
    instances.forEach((instance) => {
      if (instance.visible) updateInstance(instance);
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const instance = instances.get(entry.target);
        if (!instance) return;

        instance.visible = entry.isIntersecting;

        if (instance.visible) {
          schedule();
        } else {
          resetInstance(instance);
        }
      });
    },
    {
      root: null,
      rootMargin: '240px 0px',
      threshold: 0
    }
  );

  const setup = (root) => {
    if (!root || instances.has(root)) return;

    const media = root.querySelector('[data-ppb-media]');
    if (!media) return;

    const instance = {
      root,
      media,
      visible: false,
      strength: root.dataset.ppbStrength || 'medium',
      mobileMotion: root.dataset.ppbMobileMotion || 'static'
    };

    instances.set(root, instance);
    observer.observe(root);
  };

  const scan = (scope = document) => {
    if (scope.matches?.('[data-pro-parallax-banner]')) {
      setup(scope);
    }

    scope.querySelectorAll?.('[data-pro-parallax-banner]').forEach(setup);
    schedule();
  };

  const destroyWithin = (scope) => {
    const roots = [];

    if (scope.matches?.('[data-pro-parallax-banner]')) roots.push(scope);
    scope
      .querySelectorAll?.('[data-pro-parallax-banner]')
      .forEach((root) => roots.push(root));

    roots.forEach((root) => {
      const instance = instances.get(root);
      if (!instance) return;

      observer.unobserve(root);
      resetInstance(instance);
      instances.delete(root);
    });
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });

  reducedMotionQuery.addEventListener?.('change', schedule);
  mobileQuery.addEventListener?.('change', schedule);

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyWithin(event.target);
  });

  window[CONTROLLER_KEY] = {
    scan,
    destroyWithin
  };

  scan(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-premium-2-product-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const RUNTIME_KEY = '__pawlishPremiumTwoProductBundleRuntime';
    const LOADER_KEY = '__pawlishProductCartCoordinatorLoader';

    const previousRuntime = window[RUNTIME_KEY];
    if (previousRuntime && typeof previousRuntime.destroy === 'function') {
      previousRuntime.destroy();
    }

    const getCoordinator = () => {
      const coordinator = window.PawlishProductCartCoordinator;
      return coordinator && typeof coordinator.addPreparedItems === 'function' ? coordinator : null;
    };

    const ensureCoordinator = (root) => {
      const coordinator = getCoordinator();
      if (coordinator) return Promise.resolve(coordinator);

      if (window[LOADER_KEY]) return window[LOADER_KEY];

      const src = root?.dataset?.ppbCoordinatorSrc;
      if (!src) return Promise.reject(new Error('Cart coordinator asset is unavailable.'));

      window[LOADER_KEY] = new Promise((resolve, reject) => {
        const absoluteSrc = new URL(src, document.baseURI).href;
        const existingScript = Array.from(document.scripts).find((script) =>
          script.dataset.pawlishCartCoordinatorScript === 'true' || script.src === absoluteSrc
        );
        const script = existingScript || document.createElement('script');

        const handleLoad = () => {
          const readyCoordinator = getCoordinator();
          if (readyCoordinator) {
            resolve(readyCoordinator);
            return;
          }
          reject(new Error('Cart coordinator did not initialize.'));
        };
        const handleError = () => reject(new Error('Cart coordinator failed to load.'));

        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });

        if (!existingScript) {
          script.src = src;
          script.defer = true;
          script.dataset.pawlishCartCoordinatorScript = 'true';
          document.head.appendChild(script);
        }
      }).catch((error) => {
        window[LOADER_KEY] = null;
        throw error;
      });

      return window[LOADER_KEY];
    };

    const onClick = async (event) => {
      const button = event.target.closest?.('[data-ppb-add]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      const root = button.closest('[data-ppb-root]');
      if (!root) return;

      const errorElement = root.querySelector('[data-ppb-error]');
      if (errorElement) {
        errorElement.textContent = '';
        errorElement.hidden = true;
      }

      const items = Array.from(root.querySelectorAll('[data-ppb-item][data-variant-id]'))
        .map((item) => ({
          id: Number(item.dataset.variantId || 0),
          quantity: 1,
        }))
        .filter((item) => item.id > 0);

      if (items.length !== 2) {
        if (errorElement) {
          errorElement.textContent = 'Both products must be available before adding the bundle.';
          errorElement.hidden = false;
        }
        return;
      }

      try {
        const coordinator = await ensureCoordinator(root);
        await coordinator.addPreparedItems(items, root, button, {
          source: 'pro-premium-two-product-bundle',
        });
      } catch (error) {
        if (!errorElement) return;
        errorElement.textContent =
          error?.description || error?.message || 'Unable to add the bundle. Please try again.';
        errorElement.hidden = false;
      }
    };

    document.addEventListener('click', onClick);

    window[RUNTIME_KEY] = {
      destroy() {
        document.removeEventListener('click', onClick);
      },
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
